
  import { defineComponent, PropType } from 'vue';

  import FilterFactory from '@/common/components/redesigned/Filter/FilterFactory.vue';
  import { TFilterConfig, TFilterDate, TFilterSelect } from '@/common/components/redesigned/Filter/types/filter';
  import { getCurrentDate, getRuCurrentDate, getRuStartCurrentDate } from '@/common/utils/dates';

  import { ContextTypes } from '@/modules/admin/types/statistics/common';

  import { STATISTICS_CONTEXTS } from '../../constants/statistics';
  import { TStatisticsPublicFilter } from '../../types/statistics/statistics-public';

  export default defineComponent({
    name: 'StatisticsFilter',
    components: { FilterFactory },
    emits: {
      searchFilter: (value: TStatisticsPublicFilter) => value !== undefined,
    },
    props: {
      filtersConfig: {
        type: Array as PropType<TFilterConfig[]>,
        default: () => [],
      },
    },
    computed: {
      getFiltersConfig() {
        const baseFilterConfig: [TFilterDate, TFilterSelect<{ id: ContextTypes; name: string }>] = [
          {
            type: 'date',
            label: 'Период',
            vModel: 'datePeriod',
            placeholders: [getRuStartCurrentDate(), getRuCurrentDate()],
            typeable: true,
            limits: {
              to: getCurrentDate(),
            },
          },
          {
            type: 'select',
            label: 'В разрезе',
            options: STATISTICS_CONTEXTS,
            valueProp: 'id',
            labelProp: 'name',
            vModel: 'contextId',
            placeholder: 'По месяцам',
            clearable: true,
          },
        ];
        return [...this.filtersConfig, ...baseFilterConfig];
      },
    },
    methods: {
      searchFilter(filter: TStatisticsPublicFilter) {
        this.$emit('searchFilter', filter);
      },
    },
  });
